module.exports = __webpack_public_path__ + "static/media/icon-category-white.89c3e6ab.svg";